import React from "react";
import { ChevronRight } from "lucide-react";
import { LinkAnchor } from "../../components/ui/link";
import { ContractorSeoLayout } from "./ContractorSeoLayout";
import type { ContractorSeoIndexPageProps } from "./types";

export const ContractorSeoIndexPage: React.FC<ContractorSeoIndexPageProps> = (
  props,
) => {
  const { title, intro, items } = props;

  return (
    <ContractorSeoLayout {...props}>
      <article className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        <header className="mb-10">
          <p className="text-sm font-medium uppercase tracking-wide text-accent">
            {props.business.businessName}
          </p>
          <h1 className="mt-2 font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            {title}
          </h1>
          <p className="mt-4 text-base text-muted-foreground">{intro}</p>
        </header>

        <ul className="grid gap-4 sm:grid-cols-2">
          {items.map((item) => (
            <li key={item.href}>
              <LinkAnchor
                href={item.href}
                className="group block h-full rounded-lg border border-border bg-card p-5 transition-colors hover:border-accent hover:no-underline"
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="font-display text-lg font-semibold text-foreground">
                      {item.label}
                    </p>
                    {item.description ? (
                      <p className="mt-1 text-sm text-muted-foreground">
                        {item.description}
                      </p>
                    ) : null}
                  </div>
                  <ChevronRight className="mt-1 h-5 w-5 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-1 group-hover:text-accent" />
                </div>
              </LinkAnchor>
            </li>
          ))}
        </ul>
      </article>
    </ContractorSeoLayout>
  );
};
